<template>
  <div>
    <ValidationObserver
      ref="observer"
      v-slot="{ valid, dirty }"
    >
      <VAutocomplete
        v-model="data.accessGroups"
        :label="$t('forms.labels.accessGroups')"
        :items="editItems"
        multiple
        outlined
        :loading="loading"
        :disabled="!hasPermission('members.accessGroups.edit')"
        data-cy="accessGroup"
        @input="updateData"
      />
      <SlotScopeWatcher
        :value="dirty"
        @change="$emit('dirtyChanged', dirty)"
      />
      <SlotScopeWatcher
        :value="valid"
        @change="$emit('validChanged', valid)"
      />
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { mapGetters } from 'vuex';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VAutocomplete,
    },
    props: {
        accessGroups: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            availableAccessGroups: [],
            loading: false,
            data: {
                accessGroups: [],
            },
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'lang',
            'teamMainLang',
        ]),
        editItems() {
            return this.availableAccessGroups.map(item => ({
                ...item,
                name: item.name[this.lang] || item.name[this.teamMainLang],
            }));
        },
    },
    watch: {
        accessGroups: {
            handler() {
                this.data.accessGroups = [...this.accessGroups];
            },
            immediate: true,
        },
    },
    created() {
        this.getAccessGroups();
    },
    methods: {
        async getAccessGroups() {
            this.loading = true;
            const { data } = await this.$rq.getAccessGroups({ pagination: false });
            this.availableAccessGroups = data.accessGroups;
            this.loading = false;
        },
        updateData() {
            this.$emit('sendData', this.data.accessGroups);
        },
    },
};
</script>
